import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showCorrectAnswers: '=',
        showAnswerFeedback: '=',
        showQuestionFeedback: '=',
        showTesteesAnswers: '=',
        formSubmission: '=',
        selectedLanguage: '=',
        showPointsAwarded: '='
    },
    template: `
        <p>
            <a ng-if="vm.isAnswersShown()"
               class="btn discrete"
               ng-click="vm.show()"
            >
                {{ 'quiz.Display correct answers' | translate }}
            </a>
        </p>
        <quiz-questions class="quiz"
            ng-if="vm.toggle && vm.questions"
            form="vm.form"
            form-submission="vm.formSubmission"
            questions="vm.questions"
            selected-language="vm.selectedLanguage"
            show-correct-answers="vm.showCorrectAnswers"
            show-answer-feedback="vm.showAnswerFeedback"
            show-question-feedback="vm.showQuestionFeedback"
            show-testees-answers="vm.showTesteesAnswers"
            show-points-awarded="vm.showPointsAwarded"
        />
    `
})
export default class {
    constructor (QuizQuestionService) {
        this.QuizQuestionService = QuizQuestionService;
    }

    $onInit () {
        this.toggle = false;
    }

    isAnswersShown () {
        return this.showCorrectAnswers || this.showAnswerFeedback || this.showQuestionFeedback || this.showTesteesAnswers;
    }

    show () {
        this.toggle = !this.toggle;
        // if toggle is false or if questions are already loaded no further action is necessary
        if (!this.toggle || this.questions) {
            return;
        }
        this.QuizQuestionService.loadQuestions(this.formSubmission, true).then(questions => {
            this.form = {
                guid: this.formSubmission.guid,
                formId: this.formSubmission.formId,
                answers: {}
            };
            this.questions = questions;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/quiz/finished/answers/index.js